<template>
  <div>
    <el-dialog
      width="838px"
      :title="id ? (isDetail ? '协议详情' : '修改协议') : '新增协议'"
      :visible="visible"
      :close-on-click-modal="false"
      @close="handleCancle"
      @closed="reset"
    >
      <!-- 新增OR编辑 -->
      <el-form
        v-loading="loading"
        ref="dealForm"
        v-if="!isDetail"
        :rules="dealRules"
        :model="dealForm"
        label-width="80px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="协议名称" prop="protocolName">
              <el-col :span="12">
                <el-input v-model="dealForm.protocolName" style="width: 319px"></el-input>
              </el-col>
              <el-col :span="24">
                <span class="tips">{{
                  '*请填写协议标准名称。例如HJ212-2017，协议名称为HJ212，协议版本为HJ212-2017'
                }}</span>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-tabs
              v-model="tabIndex"
              class="deal-taps"
              type="card"
              :closable="dealForm.protocolVersionParamList.length > 1"
              @tab-remove="typeRemove"
              @tab-add="addType"
              addable
            >
              <el-tab-pane
                v-for="(typeItem, typeIndex) in dealForm.protocolVersionParamList"
                :key="typeItem.id || typeIndex"
                :name="typeIndex + ''"
              >
                <template slot="label">
                  <!-- <span v-if="typeItem.id">{{ typeItem.protocolVersion }}</span> -->
                  <Ellipsis v-if="typeItem.id" :texts="typeItem.protocolVersion" />
                  <span v-else>{{ `${id ? '新增' : ''}协议${typeIndex + 1}` }}</span>
                </template>
                <el-col :span="12">
                  <el-form-item
                    :prop="`protocolVersionParamList.${typeIndex}.protocolVersion`"
                    label="协议版本"
                    :rules="typeRules.protocolVersion"
                  >
                    <el-input
                      v-if="!typeItem.status"
                      :maxlength="50"
                      v-model="dealForm.protocolVersionParamList[typeIndex].protocolVersion"
                    ></el-input>
                    <span v-else>
                      {{ dealForm.protocolVersionParamList[typeIndex].protocolVersion }}
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :prop="`protocolVersionParamList.${typeIndex}.simpleName`"
                    label="协议简称"
                    :rules="typeRules.simpleName"
                  >
                    <el-input
                      v-if="!typeItem.status"
                      v-model="dealForm.protocolVersionParamList[typeIndex].simpleName"
                    ></el-input>
                    <span v-else>
                      {{ dealForm.protocolVersionParamList[typeIndex].simpleName }}
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="附件">
                    <UploadFile
                      v-model="dealForm.protocolVersionParamList[typeIndex].fileList"
                      v-if="!typeItem.status"
                    />
                    <el-table
                      v-if="
                        !typeItem.status ||
                        dealForm.protocolVersionParamList[typeIndex].fileList.length
                      "
                      :data="dealForm.protocolVersionParamList[typeIndex].fileList"
                    >
                      <el-table-column
                        width="60"
                        type="index"
                        label="序号"
                        align="center"
                        :resizable="false"
                      ></el-table-column>
                      <el-table-column
                        align="center"
                        label="文件名"
                        prop="name"
                        width="558"
                        show-overflow-tooltip
                        :resizable="false"
                      >
                      </el-table-column>
                      <el-table-column align="center" label="操作" width="100" :resizable="false">
                        <template slot-scope="{ row, $index }">
                          <span class="preBtn wordBtn" @click="seeFile(row)">预览</span>
                          <span
                            style="margin-left: 8px"
                            v-if="!typeItem.status"
                            class="delBtn wordBtn"
                            @click="delFile($index)"
                            >删除
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <span v-else>{{ '-' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24" class="moment-box">
                  <el-form-item label="备注">
                    <el-button v-if="!typeItem.status" type="text" @click="addCommentRow"
                      >增加行</el-button
                    >
                    <el-table
                      v-if="!typeItem.status"
                      :data="dealForm.protocolVersionParamList[typeIndex].remark"
                      stripe
                    >
                      <el-table-column width="329" align="center" label="名称" prop="name">
                        <template slot-scope="{ $index }">
                          <el-form-item
                            :prop="`protocolVersionParamList.${typeIndex}.remark.${$index}.name`"
                            :rules="commentRules.name"
                          >
                            <el-input
                              autosize
                              type="textarea"
                              placeholder="请输入"
                              style="resize: none"
                              v-model="
                                dealForm.protocolVersionParamList[typeIndex].remark[$index].name
                              "
                            ></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column width="329" align="center" label="值" prop="value">
                        <template slot-scope="{ $index }">
                          <el-form-item
                            :prop="`protocolVersionParamList.${typeIndex}.remark.${$index}.value`"
                            :rules="commentRules.value"
                          >
                            <el-input
                              autosize
                              type="textarea"
                              placeholder="请输入"
                              style="resize: none"
                              v-model="
                                dealForm.protocolVersionParamList[typeIndex].remark[$index].value
                              "
                            ></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column width="60" align="center" label="操作">
                        <template slot-scope="{ $index }">
                          <p class="delBtn wordBtn" @click="delCommentRow($index)">删除</p>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-table
                      v-else-if="dealForm.protocolVersionParamList[typeIndex].remark.length"
                      :data="dealForm.protocolVersionParamList[typeIndex].remark"
                      stripe
                    >
                      <el-table-column width="329" align="center" label="名称" prop="name">
                      </el-table-column>
                      <el-table-column width="329" align="center" label="值" prop="value">
                      </el-table-column>
                    </el-table>
                    <span v-else>{{ '-' }}</span>
                  </el-form-item>
                </el-col>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </el-form>
      <!-- 详情 -->
      <DealDetail @getIndex="getTypeIndex" ref="dealDetail" v-if="isDetail" />
      <el-row slot="footer" class="dialog-footer" type="flex" justify="end">
        <el-button type="primary" @click="handleEdit" v-if="isDetail && !isDisabled"
          >修改</el-button
        >
        <el-button type="primary" @click="handleOk" :loading="btnLoading" v-if="!isDetail"
          >确定</el-button
        >
        <el-button @click="handleCancle">取消</el-button>
      </el-row>
    </el-dialog>
    <ValidatPass ref="validatPass" @back="validateBack" />
  </div>
</template>
<script>
import { includes, has } from 'lodash';
import config from '@/config';
import dealApi from 'api/home/deal-mangement';
import UploadFile from '@/components/UploadFile';
import { cloneDeep } from 'lodash';
import Ellipsis from '@/components/Ellipsis';
import ValidatPass from '@/components/PermissionPassword/ValidatPass';
import DealDetail from '@/views/pages/home/_components/DealDetail';
export default {
  components: {
    ValidatPass,
    DealDetail,
    UploadFile,
    Ellipsis
  },
  data() {
    return {
      isDetail: false,
      visible: false,
      btnLoading: false,
      loading: false,
      id: '',
      delTypeList: [],
      oldDealList: [],
      tabIndex: '0',
      typeListsTem: {
        protocolVersion: '',
        simpleName: '',
        fileList: [],
        remark: [
          {
            name: '',
            value: ''
          }
        ]
      },
      commentTem: {
        name: '',
        value: ''
      },
      dealForm: {
        protocolName: '',
        protocolVersionParamList: []
      },
      dealRules: {
        protocolName: [{ required: true, max: 50, message: '必填项，长度小于50', trigger: 'blur' }],
        simpleName: [{ required: true, max: 50, message: '必填项，长度小于50', trigger: 'blur' }],
        type: [{ required: true, message: '必选项', trigger: 'change' }]
      },
      typeRules: {
        protocolVersion: [
          { required: true, max: 50, validator: this.validateVersion, trigger: 'blur' }
        ],
        simpleName: [{ required: false, max: 50, message: '长度小于50', trigger: 'blur' }]
      },
      commentRules: {
        name: [{ required: false, max: 20, message: '长度小于20', trigger: 'change' }],
        value: [{ required: false, max: 50, message: '长度小于50', trigger: 'change' }]
      },
      isDisabled: false
    };
  },
  methods: {
    init(data, isDetail) {
      this.visible = true;
      if (data) {
        this.isDisabled = !!data.status;
        this.id = data.id;
      }
      this.getOldDealList();
      this.isDetail = isDetail || this.isDetail;
      !this.id && this.initForm();
      this.isDetail &&
        this.$nextTick(() => {
          this.$refs.dealDetail.init(data.id, data.versionId);
        });
    },
    initForm() {
      this.$nextTick(() => {
        this.dealForm.protocolVersionParamList = [cloneDeep(this.typeListsTem)];
      });
    },

    validateBack(flag) {
      if (flag) {
        this.visible = false;
      }
    },
    validateVersion(rule, value, callback) {
      if (!value) {
        callback(new Error('版本名称为必填项'));
        return;
      }
      const isHaveVersion = this.dealForm.protocolVersionParamList.filter(item => {
        return value == item.protocolVersion;
      });
      if (isHaveVersion.length > 1) {
        callback(new Error('版本名称重复'));
        return;
      }
      callback();
    },
    //备注相关
    addCommentRow() {
      this.dealForm.protocolVersionParamList[this.tabIndex].remark.push(cloneDeep(this.commentTem));
    },
    delCommentRow(index) {
      this.dealForm.protocolVersionParamList[this.tabIndex].remark.splice(index, 1);
    },

    // 版本相关
    addType() {
      this.dealForm.protocolVersionParamList.push(cloneDeep(this.typeListsTem));
    },
    typeRemove(index) {
      if (this.dealForm.protocolVersionParamList[index].status) {
        this.$message.warning('当前版本停用，无法删除');
        return;
      }
      if (this.dealForm.protocolVersionParamList[index].id) {
        this.delTypeList.push(this.dealForm.protocolVersionParamList[index].id);
      }
      this.dealForm.protocolVersionParamList.splice(index, 1);
      if (this.tabIndex >= index) {
        this.tabIndex == 0 ? (this.tabIndex = '0') : (this.tabIndex = this.tabIndex - 1 + '');
        return;
      }
    },

    // 按钮相关
    handleOk() {
      this.$refs.dealForm.validate(validated => {
        if (!validated) {
          return;
        }
        this.btnLoading = true;
        if (this.id) {
          this.editDeal();
        } else {
          this.addDeal();
        }
      });
    },
    addDeal() {
      let data = { ...this.dealForm };
      data.protocolVersionParamList = data.protocolVersionParamList.map(item => {
        let obj = { ...item };
        obj.remark = obj.remark.filter(remarkItem => {
          return remarkItem.name || remarkItem.value;
        });
        obj.extFile = obj.fileList.map(item => item.response.data.fileId).join(',');
        delete obj.fileList;
        return obj;
      });
      dealApi
        .addDeal(data)
        .then(res => {
          if (res.data.code !== 200) {
            return;
          }
          this.$message.success('新增协议成功');
          this.visible = false;
          this.$emit('back', true, true);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    editDeal() {
      let data = { ...this.dealForm, protocolVersionDeleteIdList: this.delTypeList };
      data.protocolVersionParamList = data.protocolVersionParamList.filter(item => !item.status);
      data.protocolVersionParamList = data.protocolVersionParamList.map(item => {
        let obj = { ...item };
        obj.remark = obj.remark.filter(remarkItem => {
          return remarkItem.name || remarkItem.value;
        });
        obj.extFile = obj.fileList.map(item => item.response.data.fileId).join(',');
        delete obj.fileList;
        delete obj.status;
        return obj;
      });
      dealApi
        .editDeal(data)
        .then(res => {
          if (res.data.code !== 200) {
            return;
          }
          this.$message.success('协议修改成功');
          this.visible = false;
          this.$emit('back', true, false);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    handleEdit() {
      this.$refs.dealDetail.reset();
      this.isDetail = false;
    },
    getDealDetail() {
      this.loading = true;
      dealApi
        .getDealDetail({ id: this.id })
        .then(res => {
          const {
            data: { data, code }
          } = res;
          if (code !== 200) {
            return;
          }
          this.$nextTick(() => {
            this.dealForm = {
              id: data.id,
              protocolName: data.protocolName,
              protocolVersionParamList: data.protocolVersionResultList.map(item => {
                return {
                  id: item.id,
                  protocolVersion: item.protocolVersion,
                  fileList: item.fileInfoList.map(item => {
                    return {
                      url: item.fileUrl,
                      name: item.fileOriginName,
                      response: {
                        data: {
                          fileId: item.fileId,
                          fileUrl: item.fileUrl
                        }
                      },
                      status: 'success',
                      data: item.fileId
                    };
                  }),
                  remark: JSON.parse(item.remark).map(item => {
                    let obj = { name: item.name, value: item.value || item.val };
                    return obj;
                  }),
                  simpleName: item.simpleName,
                  status: item.status
                };
              })
            };
            this.tabIndex =
              this.dealForm.protocolVersionParamList.findIndex(item => {
                return item.id == this.tabIndex;
              }) + '';
          });
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
          });
        });
    },
    getTypeIndex(index) {
      this.tabIndex = index;
      this.getDealDetail();
    },
    handleCancle() {
      // 发送请求时不能关闭模态框
      !this.btnLoading && (this.visible = false);
      //   this.$emit('back', false);
    },
    seeFile(data) {
      // const {
      //   response: {
      //     data: { fileUrl }
      //   }
      // } = data;
      // const url = `${config.preview_url}/onlinePreview?url=${fileUrl}`;
      // window.open(url);
    },
    delFile(index) {
      this.dealForm.protocolVersionParamList[this.tabIndex].fileList.splice(index, 1);
    },
    // 列表清空
    reset() {
      this.isDetail || this.$refs.dealForm.resetFields();
      this.isDetail = false;
      this.loading = false;
      this.btnLoading = false;
      this.tabIndex = '0';
      this.id = '';
      // 存在键id则删除
      has(this.dealForm, 'id') && delete this.dealForm.id;
      this.dealForm.protocolVersionParamList = [];
      this.isDisabled = false;
      this.delTypeList = [];
    },
    // 获取已存在的协议名称
    getOldDealList() {
      dealApi.getAllDealList().then(res => {
        const {
          data: { data, code }
        } = res;
        if (code !== 200) {
          return;
        }
        this.oldDealList = data;
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-table__header .el-table__cell {
  text-align: center;
}
.moment-box /deep/ .el-table__cell .el-form-item__content {
  margin-left: 0px !important;
}
.moment-box /deep/ .el-table__body .cell {
  .el-form-item__error {
    margin: 4px 0 0 0;
    padding: 0;
    position: static;
    white-space: normal;
  }
  textarea {
    border: none;
    background-color: transparent;
    resize: none;
  }
}
.iconfont {
  font-size: 28px;
  color: #409dff;
  cursor: pointer;
}
.delBtn {
  color: #fc4c2f;
}
.preBtn {
  color: #409dfb;
}
.wordBtn {
  cursor: pointer;
}
.deal-taps /deep/ .el-tabs__header {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  .el-tabs__new-tab {
    float: none;
    margin: 0 0 0 10px;
    border-radius: 50%;
    color: #409dfb;
    border-color: #409dfb;
    flex-shrink: 0;
  }
}
.tips {
  font-size: 12px;
  color: #c0c4ce;
}
</style>